var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnitedKingdom = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "united-kingdom "
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_2357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.36844 0H0V1.5607L7.36844 6.38828V0Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 5.33594V7.36852H3.1023L0 5.33594Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 12.6318V14.6644L3.1023 12.6318H0Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20 1.5607V0H12.6316V6.38828L20 1.5607Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20 14.6644V12.6318H16.8977L20 14.6644Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.6316 13.6118V20.0001H20V18.4394L12.6316 13.6118Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20 7.36852V5.33594L16.8977 7.36852H20Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M0 18.4394V20.0001H7.36844V13.6118L0 18.4394Z",
    fill: "#41479B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M20 18.4395V16.8798L13.4557 12.6318H15.3891L20 15.6247V14.6643L16.8977 12.6318H20V11.5791H11.579V20.0002H12.6316V13.6119L20 18.4395Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M0 11.5791V12.6318H3.1023L0 14.6643V16.1409L5.40605 12.6318H7.33949L0 17.3959V18.4395L7.36844 13.6119V20.0002H8.42105V11.5791H0Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M8.42105 0H7.36844V6.38828L0 1.5607V3.26871L6.31578 7.36844H4.38234L0 4.52371V5.33586L3.1023 7.36844H0V8.42105H8.42105V0Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20 8.42105V7.36844H16.8977L20 5.33586V3.84039L14.565 7.36844H12.6316L20 2.58535V1.5607L12.6316 6.38828V0H11.579V8.42105H20Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M20 11.5789V8.42105H11.5789V0H8.42105V8.42105H0V11.5789H8.42105V20H11.5789V11.5789H20Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M5.40605 12.6318L0 16.141V17.396L7.33949 12.6318H5.40605Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M13.4557 12.6318L20 16.8798V15.6248L15.3891 12.6318H13.4557Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M6.31578 7.36828L0 3.26855V4.52355L4.38234 7.36828H6.31578Z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M14.565 7.36854L20 3.84049V2.58545L12.6316 7.36854H14.565Z",
    fill: "#FF4B55"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_2357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnitedKingdom);
export default ForwardRef;